import React from 'react'
import Expander from '../Expander'
import Text from '../Text'
import ActionButton from '../ActionButton'

export default function(notification, size = 1) {
  //const redirect = useRedirect()
  function action() {
    //window.open(redirect(notification.action), '_blank')
    if ('routerHistory' in window) {
      if (notification.action === '/panel/booking/integration') {
        ;(window as any).routerHistory.push('/integration/booking', {})
      } else {
        ;(window as any).routerHistory.push('/integration/icalendar', {})
      }
    }
  }

  return (
    <Expander size={size} id={notification.id} label={notification.subtitle}>
      <Text size={size}>
        <span dangerouslySetInnerHTML={{ __html: notification.message }} />
        <ActionButton
          size={size}
          label={notification.actionLabel}
          action={action}
        />
      </Text>
    </Expander>
  )
}
